import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import { BehaviorSubject, catchError, Observable, of, tap } from "rxjs";
import { cancelInput } from "../../../inputs";
import { HttpService } from "../http.service";
import { UserRecordsResponse } from "../../../models/admin/accounts.model";
import { SubmitResponse } from "@sgm-frontend/core";
import { UserAddInputModel, UserRole } from "../../../inputs/user.input";


@Injectable({
    providedIn: 'root'
})
export class AccountsService extends HttpService<any | cancelInput, UserRecordsResponse> {

    private accountListSubject = new BehaviorSubject<UserRecordsResponse | null>(null);
    readonly accountList$ = this.accountListSubject.asObservable();
    private accountStaffListSubject = new BehaviorSubject<UserRecordsResponse | null>(null);
    readonly accountstaffList$ = this.accountStaffListSubject.asObservable();
    constructor(
        httpClient: HttpClient,
        @Inject('API_URL') apiUrl: string,
        @Inject('API_VERSION') apiVersion: string
    ) {
        super(httpClient, apiUrl, apiVersion, 'account');
    }

    getFilteredAccounts(entity: any): Observable<UserRecordsResponse | null> {
        return this.filterAllActionPaged(entity, '').pipe(
            tap((response) => this.accountListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    getFilteredStaffAccounts(entity: any): Observable<UserRecordsResponse | null> {
        return this.filterAllActionPaged(entity, '').pipe(
            tap((response) => this.accountStaffListSubject.next(response)),
            catchError(() => of(null))
        );
    }
    deleteUserById(userId: string): Observable<SubmitResponse> {
        return this.delete(userId);
    }
    createUser(user: UserAddInputModel): Observable<SubmitResponse> {
        return this.create(user).pipe(catchError((error) => of(error)));

    }
    editUser(user: UserAddInputModel): Observable<SubmitResponse> {
        return this.update(user).pipe(catchError((error) => of(error)));

    }
    UpdateUserById(user: UserAddInputModel): Observable<SubmitResponse> {
        return this.update(user).pipe(catchError((error) => of(error)));

    }
}